import { type CanvasElementType } from '@blaze-runtime/engine-domain';

export interface ResolveFilterControlTypeOptions {
  observedType: CanvasElementType;
  targetType: CanvasElementType;
  canTransform: () => boolean;
  isFilterCapable: () => boolean;
}

export interface FilterControlResolution {
  targetType?: CanvasElementType;
  isFallback: boolean;
}

export function resolveFilterControlType({
  observedType,
  targetType,
  canTransform,
  isFilterCapable,
}: ResolveFilterControlTypeOptions): FilterControlResolution {
  if (observedType === targetType) {
    return { isFallback: false };
  }

  if (canTransform() && isFilterCapable()) {
    return { targetType, isFallback: false };
  }

  return { isFallback: true };
}
